import Head from "next/head"
import { useState, useEffect, useRef } from 'react';
import DefaultLayout from "@/components/DefaultLayout"
import GoodsComponentWithDiscountNew from '@/components/GoodsComponentWithDiscountNew'
import styles from "@/styles/afterpay.module.scss"
import Image from 'next/image'
import { Modal, Button } from 'antd';
import productApi from '@/service/modules/productApi'
import Link from "next/link";

export default function LegalAfterpay() {

  interface ProductItem {
    productID: string | number;
    name: string;
    url: string;
    imgUrl?: string;
    filename: string;
    reviewCount?: number;
    price: number;
    normalPrice: number;
    freeShipping: number;
    onSale: number;
    reduced: number;
    isNew: number;
    position?: number,
    location?: string;
    isEmailOnly: any;
    inStock?: number;
    isGroup?: number;
    promotionTypeID: string | number;
    promotion: {
      productID: number;
      promotionType: number;
      promotionPrice: number;
      normalPrice: number;
      endDate: string;
      status?: number;
      notified?: number;
      pointRate: string;
      promotionRate: number;
    };
    review: {
      avgRank: number;
      total: number;
    };
    shortDescription?: string;
    visitor?: {
      weeklyVisitors: number;
    }
    rankNum?: number;
  }

  // 首先定义类型接口
  interface CategoryProduct {
    categoryName: string;
    categoryId: string;
    items: ProductItem[]; // 如果知道items的具体类型，可以替换any为具体类型
  }

  const [visible, setVisible] = useState(false);
  const modalImageRef = useRef(''); // 使用 useRef 存储图片 URL

  const [categoryProduct, setCategoryProduct] = useState<CategoryProduct[]>([])


  // 处理点击事件，确保 modalImage 在打开弹窗前就更新
  const handleImageClick = (index: number) => {
    modalImageRef.current = `https://img.crazysales.com.au/images/newhomepage/total/afterpay-explain${index + 1}.jpg`;
    setVisible(true); // 再打开弹窗
  };

  // 关闭弹窗时清空图片
  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      modalImageRef.current = ''; // 关闭动画完成后再清空，防止 UI 闪烁
    }, 300);
  };

  // 获取页面数据
  async function getPageData() {
    try {
      let resData = await productApi.getCategoryProductTopFive()

      if (resData.data && resData.data) {
        setCategoryProduct(resData.data)
      }
    } catch (error) {
      console.log(`shop页面extra数据获取失败： `, error)
    }
  }

  // 设置页面排序的选项和默认值
  useEffect(() => {
    getPageData()
  }, [])

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles["page-afterpay"]}`}>
          <div className={styles["content"]}>
            <Image
              className={styles["banner-img"]}
              src={`https://img.crazysales.com.au/images/newhomepage/total/afterpay-banner-big.jpg`}
              alt={"banner-img"}
              width={1152}
              height={276}
            ></Image>

            <div className={`${styles["content-title"]} padding-top-24`}>
              How to Use Afterpay at CrazySales
            </div>

            <div className={styles["step-img-box"]}>
              {Array.from({ length: 6 }, (_, index) => (
                <div
                  key={index}
                  className={styles["step-img-box"]}
                  onClick={() => handleImageClick(index)}
                >
                  <Image
                    className={styles["step-item-img"]}
                    src={`https://img.crazysales.com.au/images/newhomepage/total/afterpay-tip-item${
                      index + 1
                      }.jpg`}
                    alt={`step-item-${index + 1}`}
                    width={372}
                    height={383}
                  />
                </div>
              ))}
            </div>
            {/* Ant Design 弹窗 */}
            <Modal
              width={"760px"}
              open={visible}
              footer={null}
              onCancel={handleClose}
              centered
            >
              {modalImageRef.current && (
                <Image
                  style={{
                    display: "block",
                    margin: "0 auto",
                    width: "700px",
                    height: "auto",
                  }}
                  src={modalImageRef.current}
                  alt="modal-image"
                  width={700}
                  height={450}
                />
              )}
            </Modal>

            <div className={`${styles["content-title"]} padding-top-24`}>
              Shop Now
            </div>

            {/* 在组件渲染部分 */}
            <div className={styles["category-box"]}>
              {categoryProduct.map((category) => (
                <section
                  key={category.categoryId}
                  className={styles["category-item"]}
                >
                  <div className={styles["category-name"]}>
                    {category.categoryName}
                  </div>

                  <div className={styles["product-list"]}>
                    {category.items.map((product: ProductItem) => (
                      <div className={styles["product-item"]} key={product.productID}>
                        <GoodsComponentWithDiscountNew
                          {...{
                            ...product,
                            productName: product.name,
                            productID: String(product.productID),
                            imgUrl: product.filename || "",
                            showAfterpaybenifit: true
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </section>
              ))}
            </div>

            <Button
              type="primary"
              href="/"
              className={styles["continue-shopping-btn"]}
            >
              Continue Shopping
            </Button>

            <div
              className={`${styles["afterpay-explain-title"]} padding-top-50`}
            >
              Shop Now, Enjoy Now, Pay Later
            </div>
            <div className={`${styles["afterpay-explain-desc"]} padding-top-8`}>
              {`CrazySales is one of Afterpay stores in Australia. Afterpay is a buy now, pay later platform that lets you pay for your items in 4 instalments over 6 weeks, interest free. To use Afterpay, add items to your shopping cart then select Afterpay from the available payment options. You pay for the first instalment of 25% at the time of purchase, and the remaining three instalments will be automatically deducted from your nominated debit or credit card over the following six weeks.`}
            </div>

            <div
              className={`${styles["afterpay-explain-title"]} padding-top-24`}
            >
              What Do You Need for CrazySales Afterpay?
            </div>
            <div className={`${styles["afterpay-explain-desc"]} padding-top-8`}>
              • An Australian credit card/ debit card
              <br />
              • To be 18 years of age or over
              <br />
              • To be living in Australia
              <br />
              • Have a valid and verifiable email address and mobile number
              <br />
              • Be capable of entering into a legally binding contract
              <br />
              • Credit checks apply

            </div>
            <div className={`${styles["afterpay-explain-desc"]} padding-top-8`} style={{ fontWeight: 'bold' }}>
              {`Late fees, eligibility criteria and T&Cs apply. Afterpay Australia Pty Ltd Australian Credit Licence 527911.`} For full terms and conditions visit <Link href="https://www.afterpay.com/terms" legacyBehavior><a rel="noopener noreferrer">www.afterpay.com/terms</a></Link>.
            </div>

          </div>
        </div>
      </DefaultLayout>
    </>
  )
}